import { useEmailAttribution } from '@bonusly/analytics';
import { useServerEventListener } from '@bonusly/channels';

import { useSpotlightCacheInvalidation } from '../components/spotlight';
import { fetchMarkReportFile } from '../queries/reports';

const downloadFile = async ({ file_id, file_url }: { file_id: string; file_url: string }) => {
	if (file_url && file_id) {
		// Create a temporary anchor element to trigger the download
		const link = document.createElement('a');
		link.href = file_url;
		link.download = ''; // Let the browser determine filename from URL
		link.style.display = 'none';

		// Append to body, click, and remove
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);

		fetchMarkReportFile(file_id);
	}
};

export const AppEvents = () => {
	const handleSpotlightCompletion = useSpotlightCacheInvalidation();

	useServerEventListener('CsvGenerationComplete', downloadFile);
	useServerEventListener('EmployeeSpotlightGenerationComplete', handleSpotlightCompletion);

	// Track email-originated visits (e.g., manager digest links) via UTM params
	useEmailAttribution();

	return <></>;
};
